import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

// eslint-disable-next-line import/prefer-default-export
export function fetchExportInputValuesDownloadUrl({
  workspaceId,
  jobId,
}: {
  workspaceId: string;
  jobId: string;
}) {
  return requestApi<{ url: string }>({
    method: 'POST',
    url: withDocument(`/workspaces/${workspaceId}/export-input-values-jobs/${jobId}/download`),
    credentials: true,
  }).then((response) => response.data);
}
